import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import { Row } from "react-bootstrap";

import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import AgriAssetBenefits from "./AgriAssetBenefits";
import AgriAssetFeatures from "./AgriAssetFeatures";
// Main component for Agri-Asset Stack
export default function AgriAssetStack() {

  // Data for the first section (features related to Agri-Asset Stack)
  const data1 = [
    "Content Server: The content server facilitates the management of content within the category, allowing users to upload various media types like images and videos. It includes features such as setting expiry dates for content, detailed descriptions, and attribution to content creators, ensuring organized and relevant information for users in the purchasing sector.",
    "Agri Asset Management: Agri Asset Management simplifies agricultural asset and farm management. Easily organize and track assets by type and model while seamlessly integrating with farm oversight. From generating QR codes for tracking to real-time monitoring and analysis, optimize performance effortlessly. With streamlined operations and insights, Agri Asset Management boosts agricultural efficiency.",
    "IAM: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
  ];

  // Data for the second section (supporting data storage and security)
  const data2 = [
    "S3: S3 is used for scalable, durable, and reliable cloud storage, allowing users to securely store and retrieve data of any size from anywhere on the web.",
    "DB: The database (DB) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle="Agri-Asset Stack"
        bannerbodycopy="Asset Behaviour | Site Behaviour | Actors Behaviour"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="AgriAsset" />

      {/* Features Section */}
      <Container>
        <Row>
          <OverviewFeatures data1={data1} data2={data2} />
        </Row>
      </Container>

      {/* Agri-Asset Features Section */}
      <AgriAssetFeatures />

      {/* Agri-Asset Benefits Section */}
      <AgriAssetBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href4="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}

